import { useTranslation } from 'react-i18next';
import { useGetRequiredRule, useLengthValidationRule } from '@/hooks';
import { LinkingFormFields } from '../helpers/types';

const useInterLinksFormRules = (isRequired: boolean) => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const titleLengthRule = useLengthValidationRule({ t, max: 250 });

  return {
    [LinkingFormFields.PAGE_PATH]: isRequired ? [requiredRule] : [],
    [LinkingFormFields.LINKS]: [
      {
        validator: async (_: unknown, fields: string[]) => {
          if (!fields || fields.length < 1) {
            return Promise.reject(new Error(requiredRule.message));
          }
          return Promise.resolve();
        },
      },
    ],
    [LinkingFormFields.TITLE]: isRequired ? [requiredRule, titleLengthRule] : [titleLengthRule],
    [LinkingFormFields.PATH]: isRequired ? [requiredRule, titleLengthRule] : [titleLengthRule],
  };
};

export default useInterLinksFormRules;
